/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Card_PayersInputs */

const en_admin_funnel_card_payers = /** @type {(inputs: Admin_Funnel_Card_PayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payers today`)
};

/**
* | output |
* | --- |
* | "Payers today" |
*
* @param {Admin_Funnel_Card_PayersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_card_payers = /** @type {((inputs?: Admin_Funnel_Card_PayersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Card_PayersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_card_payers(inputs)
});
export { admin_funnel_card_payers as "admin.funnel.card.payers" }